/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientCaseModel } from '../../models/patient-case-model';
import { PatientCloseCaseModel } from '../../models/patient-close-case-model';

export interface PatientCloseCasePost$Params {
      body?: PatientCloseCaseModel
}

export function patientCloseCasePost(http: HttpClient, rootUrl: string, params?: PatientCloseCasePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientCaseModel>>> {
  const rb = new RequestBuilder(rootUrl, patientCloseCasePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<PatientCaseModel>>;
    })
  );
}

patientCloseCasePost.PATH = '/Patient/CloseCase';
